import { NotebookTypes } from '@mode/notebooks/contract';

export interface NotebookLibrary {
  label: string;
  description: string;
  href: string;
  group: Array<LibraryGroupKey>;
  environments: Array<NotebookTypes.NotebookType>;
  keywords?: Array<string>;
}

export interface LibraryGroup {
  label: string;
  key: LibraryGroupKey;
}

export enum LibraryGroupKey {
  frequent = 'Frequently Used',
  wrangling = 'Data Manipulation & Wrangling',
  stats = 'Machine Learning & Statistics',
  viz = 'Visualization',
  other = 'Everything Else',
}

export interface GroupedLibraries extends LibraryGroup {
  libraries: Array<NotebookLibrary>;
}
